<div sbbDialogContent [class]="getContentClassTag()">
  <table>
    <tr>
      <td>
        <table>
          <tr>
            <td class="EditTrainrunSectionDialogHeaderLeft" rowspan="2">
              <b>{{ leftBetriebspunkt[0] }}</b> {{ leftBetriebspunkt[1] }}
            </td>
            <td class="EditTrainrunSectionDialogHeaderSeparatorLeft"></td>
            <td
              [ngClass]="
                tagNbrStopInput
                  ? 'EditTrainrunSectionDialogHeaderCenter IsActive'
                  : 'EditTrainrunSectionDialogHeaderCenter NotActive'
              "
              rowspan="2"
            >
              <input
                tabindex="-1"
                id="NumberOfStopsInputElementMinus"
                class="NumberOfStopsInputButtonPlusMinus"
                (click)="onInputNumberOfStopsElementButtonMinus()"
                (mouseenter)="onMouseEnterNbrStopInput()"
                (mouseleave)="onMouseOutNbrStopInput()"
                value="-"
                type="button"
              />

              <input
                tabindex="-1"
                id="NumberOfStopsInputElement"
                [class]="getNumberOfStopsInputElementClass()"
                type="number"
                min="0"
                max="99"
                maxlength="2"
                spellcheck="false"
                pattern="^[0-9.]*"
                [(ngModel)]="numberOfStops"
                (change)="onNumberOfStopsChanged()"
                (mouseenter)="onMouseEnterNbrStopInput()"
                (mouseleave)="onMouseOutNbrStopInput()"
              />

              <input
                tabindex="-1"
                id="NumberOfStopsInputElementPlus"
                class="NumberOfStopsInputButtonPlusMinus"
                (click)="onInputNumberOfStopsElementButtonPlus()"
                (mouseenter)="onMouseEnterNbrStopInput()"
                (mouseleave)="onMouseOutNbrStopInput()"
                value="+"
                type="button"
              />
            </td>
            <td class="EditTrainrunSectionDialogHeaderSeparatorRight"></td>
            <td class="EditTrainrunSectionDialogHeaderRight" rowspan="2">
              <b>{{ rightBetriebspunkt[0] }}</b> {{ rightBetriebspunkt[1] }}
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr></tr>
    <tr>
      <td height="6px"></td>
    </tr>
    <tr>
      <td>
        <div class="mainGridLayout">
          <div class="TravelFreqLeft">
            <svg class="renderer" width="192px" height="32px" border="0" viewBox="0 6 96 16">
              <path [class]="getEdgeLineClassAttrString(0)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(1)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(2)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(3)" d="M0,16L192,16"></path>
              <path
                [class]="getEdgeLineArrowClassAttrString()"
                d="M0,5L0,-5L8,0Z"
                [attr.transform]="getArrowTranslateAndRotate()"
              ></path>
            </svg>
          </div>
          <div class="TravelFreqRight">
            <svg class="renderer" width="192px" height="32px" border="0" viewBox="0 6 96 16">
              <path [class]="getEdgeLineClassAttrString(0)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(1)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(2)" d="M0,16L192,16"></path>
              <path [class]="getEdgeLineClassAttrString(3)" d="M0,16L192,16"></path>
              <path
                [class]="getEdgeLineArrowClassAttrString()"
                d="M0,5L0,-5L8,0Z"
                [attr.transform]="getArrowTranslateAndRotate()"
              ></path>
            </svg>
          </div>

          <sbb-time-stepper
            *ngIf="isBottomTrainrunSectionInfoDisplayed"
            [containerClass]="getTrafficSideClass('NodeLeftArrival')"
            inputId="NodeLeftArrivalTimeInputElement"
            inputClass="InputElement lastInput"
            [tabIndex]="6"
            [(value)]="trainrunSectionTimesService.getTimeStructure().leftArrivalTime"
            (changed)="trainrunSectionTimesService.onNodeLeftArrivalTimeChanged()"
            (decrement)="trainrunSectionTimesService.onNodeLeftArrivalTimeButtonMinus()"
            (increment)="trainrunSectionTimesService.onNodeLeftArrivalTimeButtonPlus()"
            #leftArrivalTimeInputElement
          ></sbb-time-stepper>
          <sbb-time-stepper
            *ngIf="isTopTrainrunSectionInfoDisplayed"
            [containerClass]="getTrafficSideClass('NodeLeftDeparture')"
            inputId="NodeLeftDepartureTimeInputElement"
            inputClass="InputElement firstInput"
            [tabIndex]="2"
            [(value)]="trainrunSectionTimesService.getTimeStructure().leftDepartureTime"
            (changed)="trainrunSectionTimesService.onNodeLeftDepartureTimeChanged()"
            (decrement)="trainrunSectionTimesService.onNodeLeftDepartureTimeButtonMinus()"
            (increment)="trainrunSectionTimesService.onNodeLeftDepartureTimeButtonPlus()"
            #leftDepartureTimeInputElement
          ></sbb-time-stepper>
          <sbb-time-stepper
            *ngIf="isTopTrainrunSectionInfoDisplayed"
            [containerClass]="getTrafficSideClass('NodeRightArrival')"
            inputId="NodeRightArrivalTimeInputElement"
            inputClass="InputElement"
            [tabIndex]="4"
            [(value)]="trainrunSectionTimesService.getTimeStructure().rightArrivalTime"
            (changed)="trainrunSectionTimesService.onNodeRightArrivalTimeChanged()"
            (decrement)="trainrunSectionTimesService.onNodeRightArrivalTimeButtonMinus()"
            (increment)="trainrunSectionTimesService.onNodeRightArrivalTimeButtonPlus()"
            #rightArrivalTimeInputElement
          ></sbb-time-stepper>
          <sbb-time-stepper
            *ngIf="isBottomTrainrunSectionInfoDisplayed"
            [containerClass]="getTrafficSideClass('NodeRightDeparture')"
            inputId="NodeRightDepartureTimeInputElement"
            inputClass="InputElement"
            [tabIndex]="5"
            [(value)]="trainrunSectionTimesService.getTimeStructure().rightDepartureTime"
            (changed)="trainrunSectionTimesService.onNodeRightDepartureTimeChanged()"
            (decrement)="trainrunSectionTimesService.onNodeRightDepartureTimeButtonMinus()"
            (increment)="trainrunSectionTimesService.onNodeRightDepartureTimeButtonPlus()"
            #rightDepartureTimeInputElement
          ></sbb-time-stepper>
          @if (isOneWayReversed) {
            <sbb-time-stepper
              [containerClass]="getTrafficSideClass('TravelTime')"
              inputId="BottomTravelTimeTimeInputElement"
              [inputClass]="{
                InputTravelTimeElement:
                  !trainrunSectionTimesService.getHighlightBottomTravelTimeElement(),
                InputTravelTimeElementHighlighted:
                  trainrunSectionTimesService.getHighlightBottomTravelTimeElement(),
              }"
              [tabIndex]="3"
              [(value)]="trainrunSectionTimesService.getTimeStructure().bottomTravelTime"
              [min]="0.0001"
              (changed)="trainrunSectionTimesService.onBottomTravelTimeChanged()"
              (decrement)="trainrunSectionTimesService.onBottomTravelTimeButtonMinus()"
              (increment)="trainrunSectionTimesService.onBottomTravelTimeButtonPlus()"
              #bottomTravelTimeInputElement
            ></sbb-time-stepper>
          } @else {
            <sbb-time-stepper
              [containerClass]="getTrafficSideClass(getTravelTimeCssClass('TravelTime'))"
              inputId="TravelTimeTimeInputElement"
              [inputClass]="{
                InputTravelTimeElement:
                  !trainrunSectionTimesService.getHighlightTravelTimeElement(),
                InputTravelTimeElementHighlighted:
                  trainrunSectionTimesService.getHighlightTravelTimeElement(),
              }"
              [tabIndex]="3"
              [(value)]="trainrunSectionTimesService.getTimeStructure().travelTime"
              [min]="0.0001"
              (changed)="trainrunSectionTimesService.onTravelTimeChanged()"
              (decrement)="trainrunSectionTimesService.onTravelTimeButtonMinus()"
              (increment)="trainrunSectionTimesService.onTravelTimeButtonPlus()"
              #travelTimeInputElement
            ></sbb-time-stepper>
          }
          <sbb-time-stepper
            *ngIf="isBottomTravelTimeDisplayed"
            [containerClass]="getTrafficSideClass('BottomTravelTime')"
            inputId="BottomTravelTimeTimeInputElement"
            [inputClass]="{
              InputTravelTimeElement:
                !trainrunSectionTimesService.getHighlightBottomTravelTimeElement(),
              InputTravelTimeElementHighlighted:
                trainrunSectionTimesService.getHighlightBottomTravelTimeElement(),
            }"
            [tabIndex]="3"
            [(value)]="trainrunSectionTimesService.getTimeStructure().bottomTravelTime"
            [min]="0.0001"
            (changed)="trainrunSectionTimesService.onBottomTravelTimeChanged()"
            (decrement)="trainrunSectionTimesService.onBottomTravelTimeButtonMinus()"
            (increment)="trainrunSectionTimesService.onBottomTravelTimeButtonPlus()"
            #bottomTravelTimeInputElement
          ></sbb-time-stepper>

          <div
            class="focusguard"
            id="focusguard-1"
            tabindex="1"
            (focus)="setFocusToEndOfLoop()"
          ></div>
          <div
            class="focusguard"
            id="focusguard-2"
            tabindex="7"
            (focus)="setFocusToBeginningOfLoop()"
          ></div>

          <sbb-toggle-switch-button
            class="LeftSymmetryToggle"
            *ngIf="isRoundTrip()"
            [checked]="!trainrunSectionTimesService.getSymmetryStructure().leftSymmetry"
            (checkedChanged)="trainrunSectionTimesService.onLeftNodeSymmetryToggle(!$event)"
            #leftSymmetryToggle
          ></sbb-toggle-switch-button>
          <sbb-toggle-switch-button
            class="RightSymmetryToggle"
            *ngIf="isRoundTrip()"
            [checked]="!trainrunSectionTimesService.getSymmetryStructure().rightSymmetry"
            (checkedChanged)="trainrunSectionTimesService.onRightNodeSymmetryToggle(!$event)"
            #rightSymmetryToggle
          ></sbb-toggle-switch-button>

          <div [ngClass]="getTravelTimeCssClass('TravelTimeLock')">
            <div *ngIf="trainrunSectionTimesService.getLockStructure().travelTimeLock === false">
              <sbb-icon
                svgIcon="lock-open-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonTravelTimeLock()"
              >
              </sbb-icon>
            </div>
            <div *ngIf="trainrunSectionTimesService.getLockStructure().travelTimeLock === true">
              <sbb-icon
                svgIcon="lock-closed-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonTravelTimeLock()"
              >
              </sbb-icon>
            </div>
          </div>
          <div class="NodeLeftLock">
            <div *ngIf="trainrunSectionTimesService.getLockStructure().leftLock === false">
              <sbb-icon
                svgIcon="lock-open-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonNodeLeftLock()"
              >
              </sbb-icon>
            </div>
            <div *ngIf="trainrunSectionTimesService.getLockStructure().leftLock === true">
              <sbb-icon
                svgIcon="lock-closed-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonNodeLeftLock()"
              >
              </sbb-icon>
            </div>
          </div>
          <div class="NodeRightLock">
            <div *ngIf="trainrunSectionTimesService.getLockStructure().rightLock === false">
              <sbb-icon
                svgIcon="lock-open-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonNodeRightLock()"
              >
              </sbb-icon>
            </div>
            <div *ngIf="trainrunSectionTimesService.getLockStructure().rightLock === true">
              <sbb-icon
                svgIcon="lock-closed-medium"
                height="25px"
                width="25px"
                aria-hidden="false"
                (click)="trainrunSectionTimesService.onButtonNodeRightLock()"
              >
              </sbb-icon>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
<div sbbDialogActions [class]="getContentFooterClassTag()">
  <button
    class="warning"
    *ngIf="trainrunSectionTimesService.getShowWarningTwoLocks() === true"
    disabled
  >
    {{
      "app.view.dialogs.trainrun-and-section-dialog.trainrun-section-tab.warningTwoLocks"
        | translate
    }}
  </button>
  <button
    class="FunctionButton"
    tabindex="-1"
    mode="icon"
    (click)="trainrunSectionTimesService.onPropagateTimeLeft(selectedTrainrunSection)"
    [title]="
      'app.view.dialogs.trainrun-and-section-dialog.trainrun-section-tab.propagateTimesToLeft'
        | translate
    "
  >
    <sbb-icon
      svgIcon="arrow-long-left-medium"
      height="13px"
      width="13px"
      aria-hidden="false"
    ></sbb-icon>
  </button>
  <button
    class="FunctionButton"
    tabindex="-1"
    mode="icon"
    (click)="trainrunSectionTimesService.onPropagateTimeRight(selectedTrainrunSection)"
    [title]="
      'app.view.dialogs.trainrun-and-section-dialog.trainrun-section-tab.propagateTimesToRight'
        | translate
    "
  >
    <sbb-icon
      svgIcon="arrow-long-right-medium"
      height="13px"
      width="13px"
      aria-hidden="false"
    ></sbb-icon>
  </button>
</div>
